import type { UseQueryResult } from "@tanstack/react-query";

import type { AiTrackerReportsBrandOverviewPeriodChangesResponse } from "@similarweb/pro-api-client";

import { customRequest } from "app/modules/api-client";
import { useLLMReportQuery } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMReportQuery";
import type { ILLMWidgetRequestParams } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

const fetchPeriodChanges = (
    params: ILLMWidgetRequestParams,
): Promise<AiTrackerReportsBrandOverviewPeriodChangesResponse | null> =>
    customRequest<AiTrackerReportsBrandOverviewPeriodChangesResponse | null>({
        path: "/api/aiTracker/reports/brandVisibilityReport/PeriodChanges",
        method: "GET",
        query: params,
        format: "json",
    });

export const usePeriodChangesData = (
    params: ILLMWidgetRequestParams,
    options?: { enabled?: boolean },
): UseQueryResult<AiTrackerReportsBrandOverviewPeriodChangesResponse | null> =>
    useLLMReportQuery<AiTrackerReportsBrandOverviewPeriodChangesResponse | null, ILLMWidgetRequestParams>(
        "periodChanges",
        fetchPeriodChanges,
        params,
        { enabled: options?.enabled },
    );
